import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";

const MemberSnapshot = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("race")
  ],
  data () {
    return {
      memberId: "",
      memberUserId: "",
      startOfRaceMu: 0,
      startOfRaceSigma: 0
    };
  }
};

export default defineReactiveModel(MemberSnapshot);
